<template>
  <div
    class="dataArrayOutput tele_width"
    v-for="t in telebarqs_display"
    :key="t.id"
  >
    <template v-if="t.teleId == 'own'">
      <div class="Telebarq_PopUp writeTele">
        <div class="innerPopUp gray">
          <div class="orange_border">
            <div class="top">
              <div class="newmessageto">NEW MESSAGE TO:</div>
              <div class="actors">
                <div
                  v-for="(a, i) in actors"
                  :key="a"
                  class="pointer"
                  :class="t.actor == i ? 'selected_actor' : ''"
                >
                  {{ a }}
                </div>
              </div>

              <div class="close pointer" @click="closeTelebarq(t.id)">
                <img src="../assets/close.svg" />
              </div>
            </div>

            <div class="writeTele_white">
              <div class="content">
                <textarea
                  :value="t.rawData"
                  class="text1"
                  cols="1"
                  rows="5"
                  maxlength="250"
                  style="font-size: 17px"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="Telebarq_PopUp">
        <div class="antwort">Answer from {{ t.userName }}</div>
        <div class="innerPopUp" :style="t.style">
          <div class="close pointer" @click="closeTelebarq(t.id)">
            <img src="../assets/close.svg" />
          </div>
          <template v-if="t.special">
            <template v-for="(s, i) in teles[t.teleId].special" :key="i">
              <input
                v-if="s.type == 'input'"
                :value="t.rawData.inputs[i]"
                type="text"
                :style="s.style"
                class="abs notouch"
              />
              <textarea
                v-if="s.type == 'textarea'"
                :value="t.rawData.textarea"
                maxlength="330"
                :style="s.style"
                class="abs notouch text2"
              />
              <img
                v-if="s.type == 'canvas'"
                :src="t.rawData.canvas"
                :style="s.style"
                class="abs"
              />
            </template>
          </template>
          <template v-else>
            <div class="replyTele">
              <div class="replyBorder"></div>
              <div>ANSWER FROM: {{ t.userName }}</div>
              <div>
                {{ t.rawData.textarea }}
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import Teles from "../../telebarq.json";

export default {
  name: "TelebarqGM_output",
  emits: ["resetPopUp", "msg", "addToPlayerData"],
  props: {
    telebarqs: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentOpenTele: "",
      closeClass: "",
      replyTele: "",
      textarea: "",
      inputs: [],
      coolDownTimer: null,
      teles: Teles,
      imageStyle: "",
      telebarqs_display: [],
      actors: [
        "ROYA",
        "LARRY",
        "FRABANK",
        "XENIA",
        "ANDRE",
        "SALLY",
        "AISHA",
        "EMMA",
        "JUAN",
      ],
    };
  },
  watch: {
    telebarqs: function (newVal) {
      // watch it
      console.log(newVal);
      this.telebarqs_display = newVal;
      for (var i = 0; i < newVal.length; i++) {
        this.telebarqs_display[i].style = this.loadTele(
          newVal[i].sprache,
          newVal[i].teleId
        );
      }

      console.log(this.telebarqs_display);
    },
  },

  methods: {
    closeTelebarq(id) {
      let data = {
        id: id, //time
        name: "GM",
        type: "telebarq_delete",
      };
      console.log(data);

      this.$emit("addToPlayerData", data);
      this.$emit("msg", "Telebarq deleted");
    },
    loadTele(sprache, teleId) {
      if (teleId == "own") return "";
      console.log("LOAD TELE");
      if (!sprache) sprache = "english";
      console.log("TRYING TO LOAD:" + teleId);
      let img = "";
      let img2 = "";
      try {
        img = require("../assets/Telebarq/" + sprache + "/" + teleId + ".png");
      } catch (e) {
        console.log("img not found");
        this.$emit("msg", "Could not load Telebarq1");
        img = "";
      }
      try {
        img2 = require("../assets/Telebarq/" +
          sprache +
          "/min/" +
          teleId +
          ".jpg");
      } catch (e) {
        this.$emit("msg", "Could not load Telebarq2");
        console.log(
          "NOT FOUND IN PATH ../assets/Telebarq/" +
            sprache +
            "/min/" +
            teleId +
            ".jpg"
        );
        console.log(e);
        img2 = "";
      }

      return "background-image: url('" + img + "'),url('" + img2 + "');";
    },
  },
  created() {
    // console.log(
    //   "TELEBARQ CREATED +++++++++++++++++++++++++++++++++++++++++++++"
    // );
    // console.log(this.telebarqs);
  },
  mounted() {
    // console.log(
    //   "TELEBARQ MOUNTED ++++++++++++++++++++++++++++++++++++++++++++"
    // );
  },
};
</script>

<style scoped>
.newmessageto {
  text-align: center;
  max-width: 140px;
  color: var(--barq-orange);
}

.writeTele textarea {
  height: 340px;
}

.top {
  position: relative;
  display: flex;
  align-items: center;
}
.orange_border {
  border: 4px solid var(--barq-orange);
  margin: 10px;
  border-radius: 20px;
  height: calc(100% - 48px);
  padding: 10px;
}

.actors {
  display: flex;
  width: 240px;
  flex-wrap: wrap;
}

.actors > div {
  flex: 0 0 62px;
  background: white;
  margin: 2px;
  padding: 3px;
  text-align: center;
  border: 3px solid var(--barq-orange);
  color: var(--barq-orange);
  border-radius: 7px;
  font-size: 12px;
}

.actors > div:hover {
  background: var(--barq-orange);
  color: white;
  border: 3px solid white;
}

.selected_actor {
  background: var(--barq-orange) !important;
  color: white !important;
  border: 3px solid white !important;
}

.gray {
  background: #f2f2f2;
}

.writeTele .send {
  right: 40px;
  top: 0px;
}

.writeTele .close {
  width: 27px;
  height: 27px;
  right: 0px;
  top: 0px;
}

.close {
  border: 2px solid var(--barq-orange);
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  background: white;
  right: 27px;
  top: 69px;
}

.close:hover {
  background: var(--barq-orange);
}

.close:hover img {
  filter: brightness(10);
}

.close > img {
  width: 35px;
  position: absolute;
  top: calc(50%);
  left: calc(50%);
  transform: translateY(-50%) translateX(-50%);
}

.antwort {
  position: absolute;
  background: white;
  left: 193px;
  top: 14px;
  padding: 15px;
  font-size: 30px;
  width: 177px;
  text-align: center;
}

.tele_width {
  width: 500px;
}

.notouch {
  pointer-events: none;
}

.text1 {
  width: 90%;
  margin: 0 auto;
}

textarea {
  resize: none;
  display: block;
  overflow: hidden;
}

.abs {
  position: absolute;
}

.reply {
  position: absolute;
  right: 66px;
  top: 70px;
  width: 32px;
  height: 32px;
  /* border: 1px solid red; */
}

.replyTele {
  position: absolute;
  bottom: calc(50% - 270px);
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 440px;
  text-align: center;
  color: var(--barq-orange);
  background: white;
}

.replyTele > div {
  margin-bottom: 15px;
}

.replyBorder {
  width: 90%;
  margin: 0 auto;
  border-top: 3px solid var(--barq-orange);
}

.Telebarq_PopUp {
  position: relative;
}

.innerPopUp {
  width: 500px;
  height: 488px;
  background-repeat: no-repeat, no-repeat;
  background-size: 500px;
  border-radius: 18px;
}
</style>
